module.exports = __webpack_public_path__ + "ec60af11c88d0e9e782a2579f3ffb2e8.MP3";